export default "__VITE_ASSET__DQCx8R6C__"